import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {EditDataService} from "../services/edit-data.service";
import {ToastsManager} from "ng2-toastr";
import {LoggerService} from "../services/logger.service";

@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.scss']
})
export class ConfigComponent implements OnInit {

  public password: any;
  public files: any;
  public logData: string;
  public activeLogDate: string;
  public properties = [];
  public maintenanceEnabled = false;
  public maintenanceMessage = '';

  constructor(public editDataService: EditDataService
    , public toastr: ToastsManager
    , public vRef: ViewContainerRef
    , public loggerService: LoggerService) {

    this.password = this.editDataService.password;

  }

  ngOnInit() {
    this.properties = this.editDataService.defaultData;
    for(let item in this.properties) {
      if (item == 'unlockInactiveIndenture' || item == 'unlockInactiveIndentureAfterPortmone') {
        this.properties[item] = (+this.properties[item] / 1000) / 60;
      }
    }
    this.editDataService.getMaintenanceStatus().subscribe(
      settings => {
        this.maintenanceEnabled = settings.enabled;
        this.maintenanceMessage = settings.message;
      },
      error => this.toastr.error('Не вдалося завантажити статус технічних робіт')
    );
  }

  public save(key) {
    console.log(this.properties[key]);
    let tempProperties = {};
    if (key == 'unlockInactiveIndenture' || key == 'unlockInactiveIndentureAfterPortmone') {
      tempProperties[key] = ''+(+this.properties[key] * 1000) * 60;
    } else {
      tempProperties[key] = this.properties[key];
    }

    return this.editDataService
      .updateConfig(tempProperties)
  }

  public getProperties() : Array<string> {
    return Object.keys(this.properties).filter(key =>
      key !== 'maintenanceEnabled' && key !== 'maintenanceMessage'
    )
  }

  public saveMaintenance() {
    this.editDataService.updateMaintenanceStatus(
      this.maintenanceEnabled,
      this.maintenanceMessage
    ).subscribe(
      settings => {
        this.maintenanceEnabled = settings.enabled;
        this.maintenanceMessage = settings.message;
        this.toastr.success('Налаштування технічних робіт збережено');
      },
      error => this.toastr.error('Не вдалося зберегти налаштування технічних робіт')
    );
  }

}



// WEBPACK FOOTER //
// /home/backend/KreditCentr/WebLombard/client/src/app/config/config.component.ts